import { Injectable } from '@angular/core';
import { HttpClient, HttpResponse, HttpHeaders, HttpRequest, HttpParams } from '@angular/common/http';
// rxjs
import { BehaviorSubject, Subject, throwError } from 'rxjs';
import { Observable } from 'rxjs';
// services
import { ErrorHandler } from './../../shared/services/error-handler.service';
// path globals
import { API_PATH,SUBSCRIPTION_KEY, GET_BOOKING_DETAILS, ADD_IMAGE } from '../../shared/globals';
// store
import { Store } from '@ngrx/store';
// models
import { AppState } from '../../booking/models/app-state.interface';
import { AppLoaderService } from '../../shared/services/app-loader.service';

@Injectable({
  providedIn: 'root',
})
export class BookingDetailsService {

  private _token;

  public bookingDetailsItem$: Subject<any> = new Subject();
  public flightChangeClick$: Subject<string> = new BehaviorSubject<string>('');

  constructor(
    private _http: HttpClient,
    private _appStore: Store<AppState>,
    private _errorService: ErrorHandler,
    private _appLoaderService: AppLoaderService
  ) { }

  createAuthorizationHeader(headers: HttpHeaders, tokenFromCall?) {
    const userToken = typeof this._token === 'undefined' ? tokenFromCall : this._token;
    headers = headers.set('Authorization', 'bearer ' + userToken);
    return headers;
  }

  getUserBookingByReference(token, bookingReference) {

    //const headers = new HttpHeaders();
    //headers.append('Ocp-Apim-Subscription-Key', SUBSCRIPTION_KEY);
    let headers = new HttpHeaders();
    headers = headers.set('Ocp-Apim-Subscription-Key', SUBSCRIPTION_KEY);
    headers = this.createAuthorizationHeader(headers, token);

    const params: URLSearchParams = new URLSearchParams();
    params.set('bookingReference', bookingReference);

    this._http.get(API_PATH + GET_BOOKING_DETAILS + '?' + params, {headers: headers})
      .subscribe(
        (res: any) => {
          this.bookingDetailsItem$.next(res);
        },
        err => {
          this.bookingDetailsItem$.next(throwError(() => new Error(err)));
          this._errorService.handleError(err);
          return;
        });

  }

  uploadImage(file: File, bookingReference: string, bookingJourneyReference: string, userToken: string): Observable<any> {
    let headers = new HttpHeaders();
    headers = headers.set('Ocp-Apim-Subscription-Key', SUBSCRIPTION_KEY);
    headers = this.createAuthorizationHeader(headers, userToken);

    const formData = new FormData();
    const data = {
      bookingReference: bookingReference,
      bookingJourneyReference: bookingJourneyReference,
      imageType: 'CancellationProof'
    };
    formData.append('data', JSON.stringify(data));
    formData.append('datafile', file);

    this._appLoaderService.showLoader('', true);
    return this._http.post(API_PATH + ADD_IMAGE, formData, { headers: headers });
  }

}
